<template lang="pug">
v-card.py-2.px-4.round-lg(outlined)
  div.text-sm.neutral500--text.mb-4 Fill out information below to add medication
  template(v-for="(medication, medicationIdx) in medications")
    .mb-2.d-flex.justify-space-between.align-center
      div.text-sm.font-semibold Medication {{ medicationIdx + 1 }}
      div
        v-btn.button-xs(icon x-small @click="onEditMedication(medication)")
          v-icon(small color="info") $yzi-edit-02
        v-btn.button-xs(icon x-small @click="onDeleteMedication(medicationIdx)")
          v-icon(small color="red") $yzi-trash-03
    .mb-2
      div.text-sm.font-semibold Name :
      div.text-sm {{ medication.name }}
    v-row.mb-2(no-gutters)
      v-col.mr-2(cols="6")
        div.text-sm.font-semibold Dosage :
        div.text-sm {{ medication.dosage_value }} {{ medication.dosage_unit }}
      v-col(cols="5")
        div.text-sm.font-semibold Frequency :
        div.text-sm {{ medication.frequency }}
    v-row.mb-2(no-gutters)
      v-col.mr-2(cols="6")
        div.text-sm.font-semibold Instruction :
        div.text-sm {{ medication.instruction }}
      v-col(cols="5")
        div.text-sm.font-semibold Duration :
        div.text-sm {{ medication.duration }}
    v-row.mb-2(no-gutters)
      v-col.mr-2(cols="6")
        div.text-sm.font-semibold Indication :
        div.text-sm {{ medication.indication }}
    v-divider.mt-4.mb-2
  v-btn.button-sm(color="info" block depressed @click="onAddMedication")
    .d-flex.justify-center.align-center
      v-icon.mr-2(small) mdi-plus 
      | Add medication
  //- dialogs
  add-prescription-letter-medication-dialog(v-if="openAddMedicationDialog" :open.sync="openAddMedicationDialog" :parentMedication="selectedMedication" @save="onSaveMedication")
  delete-confirmation-dialog(v-if="openConfirmDeleteDialog" :open.sync="openConfirmDeleteDialog" :loading="isDeleting" @cancel="onCancelDeleteMedication" @delete="onConfirmDeleteMedication")
    .text-lg.font-medium Are you sure you want to delete this medication?
    .text-md.mt-4 This action will be done immediately and can’t be undone. Click “Confirm” to proceed
</template>

<script>
import AddPrescriptionLetterMedicationDialog from '@/components/clinic/dialogs/AddPrescriptionLetterMedicationDialog.vue'
import DeleteConfirmationDialog from '@/components/clinic/dialogs/DeleteConfirmationDialog.vue'

export default {
  components: {
    AddPrescriptionLetterMedicationDialog, DeleteConfirmationDialog
  },
  props: {
    medications: {
      type: Array,
      default: () => {[]}
    },
  },
  data() {
    return {
      openAddMedicationDialog: false,
      openConfirmDeleteDialog: false,
      isDeleting: false,
      toRemoveIndex: null,
      selectedMedication: null
    }
  },
  methods: {
    onAddMedication () {
      this.selectedMedication = null
      this.openAddMedicationDialog = true
    },
    onSaveMedication (item) {
      this.medications.push(item)
    },
    onEditMedication (item) {
      this.selectedMedication = item
      this.openAddMedicationDialog = true
    },
    onDeleteMedication (index) {
      this.toRemoveIndex = index
      this.openConfirmDeleteDialog = true
    },
    onCancelDeleteMedication () {
      this.toRemoveIndex = null
      this.openConfirmDeleteDialog = false
    },
    onConfirmDeleteMedication () {
      this.isDeleting = true
      this.medications.splice(this.toRemoveIndex, 1)
      this.isDeleting = false
      this.openConfirmDeleteDialog = false
    }
  },
}
</script>

<style scoped>

</style>